import { POST_LOGIN_START, POST_LOGIN_SUCCESS, POST_LOGIN_ERROR, LOGOUT } from '../../types';

export default function login(state, action) {
  switch (action.type) {
    case POST_LOGIN_START:
      return { ...state };
    case POST_LOGIN_SUCCESS:
      return {
        ...state,
        isLogged: true,
        access: action.results.accessToken,
        data: action.results.user,
        error: null,
      };
    case POST_LOGIN_ERROR:
      return {
        ...state,
        isLogged: false,
        error: action.error
      };
    case LOGOUT:
      state = {}
      return {
        ...state,
        isLogged: false,
        access: null,
        data: null,
        error: null
      }
    default:
      return { ...state };
  }
}
